import { DatePickerRange as SeiueDatePickerRange } from '@seiue/ui'
import { DateTypeEnum } from 'packages/sdks-next/growp'
import React from 'react'

import { CustomerDatePickerRangeProps } from './type'
import { momentRangeToObjectRange, objectRangeToMomentRange } from './utils'

export const DatePickerRange: React.FC<CustomerDatePickerRangeProps> = ({
  disabled,
  dateType,
  placeholder,
  value,
  onChange,
  ...rest
}) => {
  return (
    <SeiueDatePickerRange
      {...rest}
      placeholder={placeholder}
      value={objectRangeToMomentRange(value, dateType)}
      onChange={(v) =>
        onChange && onChange(momentRangeToObjectRange(v, dateType))
      }
      showTime={dateType === DateTypeEnum.Time}
      disabled={disabled}
    />
  )
}
